import { useTranslation } from "react-i18next";

const PromptsSuggestion = ({ data, showPrompts, setShowPrompts, handlePromptClick, primary, promptsLoading, promptsErr, theme }) => {

    const { t } = useTranslation();

    const language = localStorage.getItem('language') || 'en';

    return (
        <div className={`propmpt-suggestion-ct relative bottom-[0px] w-full px-3 dark:!pr-0 dark:!bg-transparent bg-white pt-1 mt-0 transition ease-in-out duration-700 ${ showPrompts  ? 'que-popup-ct-shows' : 'que-popup-ct-hide' }`}>
            {theme !== 'dark' && (
                <div className="flex items-center justify-between mt-2 mb-[13px]">
                    <p className={`mb-0 text-[16px] text-black dark:!text-white font-semibold text-${language == 'ar' ? 'right': 'left'}`}>{t('Try asking')}</p>
                    <div className="cursor-pointer color-primary" onClick={() => setShowPrompts(false)}>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 1L1 13" stroke={'currentColor'} />
                            <path d="M1 1L13 13" stroke={'currentColor'} />
                        </svg>
                    </div>
                </div>
            )}
            <div className="max-h-[120px] overflow-auto dark:flex dark:items-center dark:justify-start dark:gap-[10px]">
                {
                    promptsLoading && theme !== 'dark' ? (
                        <div className="flex items-center justify-center">
                            <p className="text-[13px] text-gray-500">{t('Loading prompts')}...</p>
                        </div>
                    ) :
                    promptsErr && theme !== 'dark' ? (
                        <div className="flex items-center justify-center">
                            <p className="text-[13px] text-red-500">{t('Unable to load questions at the moment')}</p>
                        </div>
                    ) : (
                        data && data.map((item, index)=>
                            <div key={index} className="dark:bg-[#232326] bg-[#ffffff] border dark:!border-white/20 border-[#e9e9e9] rounded-[5px] px-[10px] dark:px-[20px] py-[7px] my-2 cursor-pointer dark:min-w-[300px] dark:rounded-full dark:last:mr-4" onClick={() => {handlePromptClick(item?.Question || item?.question)}}>
                                <p className={`text-[13px] mb-0 text-black dark:!text-[#b5b5b6] text-${language == 'ar' ? 'right': 'left'}`}>{item?.Question || item?.question}</p>
                            </div>
                        )
                    )
                }
            </div>
        </div>
    )
}

export default PromptsSuggestion;